import gql from 'graphql-tag';

import lessonTemplateFragment from '~/shared/graphql-queries/lesson-templates/lesson-template-fragment';

export default gql`
  mutation updateByIdLessonTemplateMutation(
    $_id: MongoID!
    $record: UpdateByIdLessonTemplateInput!
  ) {
    updateByIdLessonTemplateMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...LessonTemplateFragment
      }
      message
      title
    }
  }
  ${lessonTemplateFragment}
`;
